'use client';

import clsx from 'clsx';
import { motion } from 'framer-motion';
import { useThemeColor } from '@/hooks/useThemeColor';

type Props = {
    label: string;
    onClick?: () => void;
    className?: string;
    width?: number | string;
    height?: number;
    disabled?: boolean;
};

export default function RectButton({
    label,
    onClick,
    className,
    width = '100%',
    height = 48,
    disabled = false,
}: Props) {
    const { scheme } = useThemeColor();
    return (
        <motion.button
            whileTap={{ scale: 0.97 }}
            onClick={onClick}
            disabled={disabled}
            style={{ width, height }}
            className={clsx(
                'flex items-center justify-center rounded-none font-notojp font-bold text-base border-2 border-color-white-base',
                disabled
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : [scheme?.bg, scheme?.bgText, 'hover:brightness-110'],
                className,
            )}
        >
            {label}
        </motion.button>
    );
}
